import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 22, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, tone = "light" }) => (
  <div className="flex items-center gap-3">
    <span className="flex h-6 items-center rounded-full bg-mint px-2.5 text-[11px] font-bold text-brandDark">
      {index}
    </span>
    <span className={`eyebrow ${tone === "dark" ? "text-white/60" : "text-body"}`}>{children}</span>
  </div>
);

export const WordReveal = ({ text, className = "", delay = 0 }) => (
  <span className={className}>
    {text.split(" ").map((word, i) => (
      <span key={`${word}-${i}`} className="inline-block overflow-hidden align-bottom">
        <motion.span
          className="inline-block"
          initial={{ y: "108%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 0.75, delay: delay + i * 0.055, ease: [0.22, 1, 0.36, 1] }}
        >
          {word}&nbsp;
        </motion.span>
      </span>
    ))}
  </span>
);
